<template>
  <div id="osList">
    <filtros-borracharia>
    </filtros-borracharia>

    <div class="table-responsive">
      <table class="table table-striped tabelaInventario">
        <thead>
          <tr>
            <th scope="col">{{ $t('AÇÃO')}}</th>
            <th scope="col">{{ $t('PLACA')}}</th>
            <th scope="col">{{ $t('TIPO')}}</th>
            <th scope="col">{{ $t('CONJUNTO')}}</th>
            <th scope="col">{{ $t('AFERIÇÃO')}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(placa, index) in placas" :key="index" :style="validaDataMM(placa)">
            <th class="d-flex" scope="row">
              <b-button class="btn btn-info m-1" v-b-modal.modalMilimetragem @click="submitPlacaModal(placa)">
                {{ $t('AFERIÇÃO')}}
              </b-button>
              <b-button v-if="placa.ds_projeto != 'ARMAZEM'" class="btn btn-success m-1" v-b-modal.modalCalibragem @click="modalCalibragem(placa)">
                {{ $t('CALIBRAGEM')}}
              </b-button>
            </th>
            <td>{{ placa.nr_placa }}</td>
            <td>{{ placa.ds_tipoveiculo }}</td>
            <td>{{ placa.ds_conjunto }}</td>
            <td>{{ placa.mm ? placa.mm : $t('Nunca feito') + '!' | formatDate("DD/MM/YYYY")}}</td>
          </tr>
        </tbody>  
      </table>
    </div>
    <modal-milimetragem ref="childAfericao" :nr_placa="placa"></modal-milimetragem>
    <modal-calibragem ref="childMilimetragem" :nr_placa="placa"></modal-calibragem>
  </div>
</template>

<script>
import FiltrosBorracharia from '@/components/FiltrosBorracharia'
import ModalMilimetragem from '@/components/Borracharia/ModalMilimetragem'
import ModalCalibragem from '@/components/Borracharia/ModalCalibragem'

export default {
  components: {
    FiltrosBorracharia,
    ModalMilimetragem,
    ModalCalibragem
  },

  data() {  
    return {
      placa: ''
    }
  },

  computed: {
    placas() {
      const placas = this.$store.getters['borracharia/getPlacas']

      if (!placas) {
        this.$store.dispatch('borracharia/fetchFromPlacas', {})
      }

      return placas
    },
    paginacao() {
      return this.$store.getters['os/pagination']
    },
  },

  mounted() {
    this.$store.dispatch('borracharia/fetchFromPlacas', {})
  },

  methods: {
    validaDataMM(placa) {
      if(!placa.mm) {
        return placa
      }
      const data = new Date(placa.mm)

      const dataAtual = new Date();

      const diferencaEmMilissegundos = dataAtual - data;

      // Converta essa diferença de milissegundos para dias
      const diferencaEmDias = diferencaEmMilissegundos / (1000 * 60 * 60 * 24);
      
      // Verifique se o número de dias é maior que 30
      if (diferencaEmDias > 30) {
        return 'background: linear-gradient(45deg, #992d2d, #fd6565); color: #fff;'
        // console.log('A data é maior que 30 dias em relação à data atual.');
      } else if (diferencaEmDias > 20) {
        return 'background: linear-gradient(45deg, #ebc420, #fde765);'
        // console.log('A data não é maior que 30 dias em relação à data atual.');
      }

      return ''
    },
    submitPlacaModal(placa) {
      this.$store.dispatch('borracharia/getPlacaMilimetragem', { data: placa }).then(() => {
        this.$refs.childAfericao.gerarCaminhao()
        this.$refs.childAfericao.adicionarAcao()
        this.$refs.childAfericao.adicionarClassePneu()
        this.placa = placa
      })
      // this.propsPlaca = placa
    },
    modalCalibragem(placa) {
      this.$store.dispatch('borracharia/getPlacaMilimetragem', { data: placa }).then(() => {
        this.$refs.childMilimetragem.gerarCaminhao()
        this.$refs.childMilimetragem.adicionarAcao()
        this.$refs.childMilimetragem.adicionarClassePneu()
        this.placa = placa
      })
    }
  }
}
</script>

<style lang="scss">
.icon--custom {
  top: 50px;
}

// .backgroundWarning {

// }

.backgroundError {
  background: linear-gradient(45deg, #992d2d, #fd6565);
  color: #fff;
}

// .content {
//   padding: 0 0;
// }
// .container-fluid{
//   padding-right: 0px;
//   padding-left: 0px;
// }</style>